import React from 'react';
import uuid from 'uuid/v4';
import appConfig from '@nerdwallet/app-config';

var createUuidGenerator = function createUuidGenerator(_ref) {
  var _ref$prefix = _ref.prefix,
      prefix = _ref$prefix === void 0 ? 'nw-aria' : _ref$prefix;
  return function generateRandomId() {
    return "".concat(prefix, "-").concat(uuid());
  };
};

export var defaultContext = createUuidGenerator({
  prefix: appConfig === null || appConfig === void 0 ? void 0 : appConfig.CLIENT_ID
});
var IdContext = React.createContext(defaultContext);
export default IdContext;